import { Link } from "react-router-dom";
import { FlagIcon } from "react-flag-kit";
import { useState, useEffect } from "react";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "../../components/Pagination";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import Placeholder from "../../components/Placeholder/PlaceholderText";
import UsersIcon from "../../assets/images/icons/icon_students_header.svg";
import { setStudentManagement } from "../../store/slices/companyManager.slice";
import { getCountries, getLangAll, getStudentManagement } from "../../store/middleware";
import { getCompanies, getEconomicGroups, getLevels } from "../../store/middleware/generic.middleware";

import { TableUser, FilterUser } from "./styles";

function Students() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { allLingos, levels } = useSelector((state) => state.genericReducer);
  const { studentsManagement } = useSelector((state) => state.companyManagerReducer);

  const [companies, setCompanies] = useState();
  const [countries, setCountries] = useState([]);
  const [expanded, seTexpanded] = useState(false);
  const [economicgroups, setEconomicGroups] = useState();
  const [filter, setFilter] = useState({
    pageNumber: 1,
    pageSize: 20,
    name: "",
    login: "",
    focus: 0,
    struct: 0,
    lingoLanguageId: 0,
    countryId: 0,
    levelId: 0,
    coupon: 0,
    subscriptionDate: "",
    active: 0,
    demoClass: 0,
    paymentProblems: 0,
    cancelDate: "",
    b2bOnly: 0,
    economicGroupId: 0,
    companyId: 0,
  });

  const handlePagination = (page) => {
    setFilter((state) => ({ ...state, ["pageNumber"]: Number(page) }));
    dispatch(getStudentManagement({ ...filter, ["pageNumber"]: Number(page) }));
  };

  const getData = () => {
    dispatch(setStudentManagement({}));
    setFilter((state) => ({ ...state, ["lingoLanguageId"]: 0 }));

    Promise.all([
      dispatch(getLevels()),
      dispatch(getLangAll()),
      dispatch(getCountries()).then((res) => setCountries(res)),
      dispatch(getCompanies()).then((res) => setCompanies(res)),
      dispatch(getEconomicGroups()).then((res) => setEconomicGroups(res)),
      dispatch(getStudentManagement(filter)),
    ]);
  };

  const applyFilters = () => {
    if (filter.b2bOnly !== 0) setFilter((state) => ({ ...state, ["cancelDate"]: "" }));
    dispatch(getStudentManagement(filter));
  };

  const clearFilters = () => {
    const newFilters = {
      pageNumber: 1,
      pageSize: 20,
      name: "",
      login: "",
      focus: 0,
      struct: 0,
      lingoLanguageId: 0,
      countryId: 0,
      levelId: 0,
      coupon: 0,
      subscriptionDate: "",
      active: 0,
      demoClass: 0,
      paymentProblems: 0,
      cancelDate: "",
      b2bOnly: 0,
      economicGroupId: 0,
      companyId: 0,
    };

    setFilter({
      pageNumber: 1,
      pageSize: 20,
      name: "",
      login: "",
      focus: 0,
      struct: 0,
      lingoLanguageId: 0,
      countryId: 0,
      levelId: 0,
      coupon: 0,
      subscriptionDate: "",
      active: 0,
      demoClass: 0,
      paymentProblems: 0,
      cancelDate: "",
      b2bOnly: 0,
      economicGroupId: 0,
      companyId: 0,
    });
    dispatch(getStudentManagement(newFilters));
  };

  const handleShowMore = (e) => {
    e.preventDefault();
    seTexpanded((state) => !state);
  };

  const handleChange = (e) => {
    const { name, type, checked, value, tagName } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    if (
      (newValue !== undefined && name === "active") ||
      name === "coupon" ||
      name === "demoClass" ||
      name === "paymentProblems" ||
      name === "b2bOnly"
    )
      newValue = newValue === "true" ? true : false;
    else if (newValue !== undefined && tagName === "SELECT" && name !== "focus" && name !== "struct")
      newValue = parseInt(newValue);

    setFilter((state) => ({ ...state, [name]: newValue }));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") applyFilters();
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header t={t} title={t("ITEM_STUDENTS")} icon={<img src={UsersIcon} alt="UsersIcon" />} typeIcon="custom" />

        <div className="content">
          <FilterUser>
            <form className="filterContent" onKeyDown={handleKeyPress}>
              <h2>
                <i className="fa fa-filter" aria-hidden="true"></i>
                {t("FILTERS")}
              </h2>
              <form className="formulario">
                <div className="lineInput">
                  <label htmlFor="name">{t("NAME")}</label>
                  <input placeholder="User name" name="name" onChange={handleChange} value={filter.name || ""} />
                </div>
                <div className="lineInput">
                  <label htmlFor="login">{t("EMAIL")}</label>
                  <input placeholder="Email" name="login" onChange={handleChange} value={filter.login || ""} />
                </div>
                <div className="lineInput">
                  <label htmlFor="status">{t("STATUS")}</label>
                  <select name="active" value={filter.active} onChange={handleChange}>
                    <option value={0}>{t("SELECT")}</option>
                    <option value={"true"}>{t("ACTIVE")}</option>
                    <option value={"false"}>{t("INACTIVE")}</option>
                  </select>
                </div>
              </form>

              {expanded && (
                <div>
                  <hr style={{ width: "100%", margin: "0" }} />
                  <br />
                  <form className="formulario">
                    <div className="lineInput">
                      <label htmlFor="countryId">Country</label>
                      <select name="countryId" value={filter.countryId} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        {countries?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>

                      <label htmlFor="demoClass">Demo class</label>
                      <select name="demoClass" value={filter.demoClass} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        <option value={"true"}>{t("BTN_YES")}</option>
                        <option value={"false"}>{t("BTN_NO")}</option>
                      </select>

                      <label htmlFor="b2bOnly">B2B</label>
                      <select name="b2bOnly" onChange={handleChange} value={filter.b2bOnly}>
                        <option value={0}>{t("SELECT")}</option>
                        <option value={"true"}>{t("BTN_YES")}</option>
                        <option value={"false"}>{t("BTN_NO")}</option>
                      </select>
                    </div>

                    <div className="lineInput">
                      <label htmlFor="lingoLanguageId">Lingo</label>
                      <Select
                        name="lingoLanguageId"
                        onChange={handleChange}
                        className="input-lingo"
                        value={filter.lingoLanguageId}
                      >
                        <MenuItem key={"mi" + -1} value={0}>
                          {t("SELECT")}
                        </MenuItem>
                        {allLingos?.map((item, index) => (
                          <MenuItem key={index} value={item.id}>
                            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                              <FlagIcon code={item.flag} />
                              {item.description}
                            </div>
                          </MenuItem>
                        ))}
                      </Select>

                      <label htmlFor="coupon">Coupon</label>
                      <select name="coupon" value={filter.coupon} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        <option value={"true"}>{t("BTN_YES")}</option>
                        <option value={"false"}>{t("BTN_NO")}</option>
                      </select>

                      <label htmlFor="economicGroupId">Economic Group</label>
                      <select name="economicGroupId" value={filter.economicGroupId} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        {economicgroups?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="lineInput">
                      {/* <label htmlFor="focus">Focus</label>
                      <select name="focus" value={filter.focus} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        <option value={"business"}>{t("PLAN_BUSINESS")}</option>
                        <option value={"traditional"}>{t("PLAN_TRADITIONAL")}</option>
                      </select> */}

                      <label htmlFor="subscriptionDate">Subscription date</label>
                      <input
                        type="date"
                        id="subscriptionDate"
                        name="subscriptionDate"
                        value={filter.subscriptionDate}
                        onChange={handleChange}
                        min="2000-01-01"
                        max="2050-12-31"
                      />

                      <label htmlFor="cancelDate">Cancel date</label>
                      <input
                        type="date"
                        id="cancelDate"
                        name="cancelDate"
                        value={filter.cancelDate}
                        onChange={handleChange}
                        min="2000-01-01"
                        max="2050-12-31"
                      />

                      <label htmlFor="companyId">Company</label>
                      <select name="companyId" value={filter.companyId} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        {companies?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.socialName}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <div className="lineInput">
                       <label htmlFor="struct">Structure</label>
                      <select name="struct" value={filter.struct} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        <option value={"conversational"}>{t("PLAN_CONVERSATIONAL")}</option>
                        <option value={"grammatical"}>{t("PLAN_GRAMMAR")}</option>
                        <option value={"balanced"}>{t("PLAN_BALANCED")}</option>
                      </select>
                    </div>*/}
                    <div className="lineInput">
                      <label htmlFor="levelId">Levels</label>
                      <select name="levelId" value={filter.levelId} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        {levels?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.level}
                          </option>
                        ))}
                      </select>

                      <label htmlFor="paymentProblems">Payment Issues</label>
                      <select name="paymentProblems" value={filter.paymentProblems} onChange={handleChange}>
                        <option value={0}>{t("SELECT")}</option>
                        <option value={"true"}>{t("BTN_YES")}</option>
                        <option value={"false"}>{t("BTN_NO")}</option>
                      </select>
                    </div>
                  </form>
                </div>
              )}

              <div className="boxButton">
                <div className="buttons">
                  <button type="button" onClick={handleShowMore}>
                    Show more +
                  </button>
                  <button type="button" onClick={clearFilters}>
                    Clear filters
                  </button>
                  <button type="button" onClick={applyFilters}>
                    Filter
                  </button>
                </div>
              </div>
            </form>
          </FilterUser>

          <div>
            {studentsManagement?.items?.length > 0 ? (
              <TableUser>
                <div className="bigBox bigBoxTableStudent">
                  <table>
                    <thead>
                      <tr>
                        <th>{t("NAME")}</th>
                        <th>Login</th>
                        <th>{t("COUNTRY")}</th>
                        <th>Subscription Date</th>
                        <th>Lingos</th>
                        <th>Status</th>
                        <th style={{ textAlign: "center" }}>{t("OPTIONS")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {studentsManagement?.items?.map((item) => {
                        const isActiveB2C =
                          item.plans[0].B2CStatus === "Active" ||
                          item.plans[0].B2BStatus === "Active" ||
                          item.plans[0].B2CStatus === true ||
                          item.plans[0].B2BStatus === true;
                        const isCancelledB2C =
                          item.plans[0].B2CStatus === "Cancelled" ||
                          item.plans[0].B2BStatus === "Cancelled" ||
                          item.plans[0].B2CStatus === false ||
                          item.plans[0].B2BStatus === false;
                        const isPendingB2C =
                          item.plans[0].B2CStatus === "Pending" || item.plans[0].B2BStatus === "Pending";

                        return (
                          <tr key={item.userId}>
                            <td>{decryptIfEncrypted(item.userName)}</td>
                            <td>{decryptIfEncrypted(item.userLogin)}</td>
                            <td>{decryptIfEncrypted(item.countryName)}</td>
                            <td>{decryptIfEncrypted(item.subscriptionDate)}</td>
                            <td>
                              {item.flags.split(",").map((flag, i) => (
                                <FlagIcon key={i} code={flag.trim() === "CS-US-IN" ? "US" : flag.trim()} />
                              ))}
                            </td>
                            <td>
                              <span
                                className={
                                  isActiveB2C ? "activo" : isPendingB2C ? "pending" : isCancelledB2C ? "inativo" : ""
                                }
                              >
                                {isActiveB2C ? "Active" : isPendingB2C ? "Pending" : isCancelledB2C ? "Inactive" : ""}
                              </span>
                            </td>
                            <td>
                              <Link to={{ pathname: "/manage-student/" + item.userId }}>
                                <button>
                                  {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                                </button>
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  totalFound={studentsManagement.pageSize}
                  totalPages={studentsManagement.totalPages}
                  pageCurrent={studentsManagement.pageNumber}
                  totalResults={studentsManagement?.totalFound ?? 20}
                  onClick={(page, type) => handlePagination(page, type)}
                />
              </TableUser>
            ) : (
              <Placeholder pageName="users" label="No results" />
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Students;
